export default __webpack_public_path__ + "static/media/49.c3c71595.png";